/**
 * Created by fworld on 2019/9/11.
 */
import types from '../mutationTypes';
import i18n from '@/i18n/i18n'

export default {
  state: {
    navMenus: [],
    navMap: [],
    buttons: [],

    employee: {},
    connect: false,

  },
  mutations: {
    [types.SET_ENTERPRISE_NAV_MENU](state, menu) {
      state.navMenus = menu.navMenus
      state.navMap = menu.map
    },
    [types.SET_ENTERPRISE_EMPLOYEE](state, employee) {
      state.employee = employee
      let buttons = {}
      if (employee && employee.hiddenButtons) {
        employee.hiddenButtons.forEach(item => {
          buttons[item] = true
        })
        state.buttons = buttons
      }

    },
    [types.SET_NOTIFY_CONNECT](state, connect) {
      state.connect = connect
    }
  },
  actions: {
    setConnect({commit}, ok) {
      commit(types.SET_NOTIFY_CONNECT, ok)
    },
    setEnterpriseMenu({commit}, menu) {
      let map = {}
      let moduleSorts = menu
      moduleSorts.forEach((ms) => {
        map[ms.uuid] = i18n.t('t_' + ms.uuid)
        let _map = {}
        ms.modules = ms.modules || []
        ms.modules.forEach((m) => {
          _map[m.uuid] = i18n.t('t_' + m.uuid)
        })
        ms.moduleMap = _map
      })
      commit(types.SET_ENTERPRISE_NAV_MENU, {map: map, navMenus: moduleSorts})
    },

    setEnterpriseEmployee({commit}, employee) {
      commit(types.SET_ENTERPRISE_EMPLOYEE, employee)
    },

    logout({commit}) {
      commit(types.SET_ENTERPRISE_EMPLOYEE, {})
    },
  }
}
